export const CONTACT_PHONE = "+91 72076 95675";
export const CONTACT_PHONE_TEL = "+917207695675";
export const CONTACT_EMAIL = "info@wtss.co.in";
export const CONTACT_ADDRESS =
  "7th floor, Trifecta Adatto, 21, ITPL Main Rd, Garudachar Palya, Mahadevpura, Bangalore, India, Karnataka - 560048";
export const CONTACT_BRANCH_ADDRESS =
  "1st Floor, 122 Optima, Puttappa Industrial Estate, Whitefield Main Road, Mahadevapura, Bengaluru, Karnataka 560048";
export const CONTACT_BRANCH_MAP_URL =
  "https://www.google.com/maps/search/?api=1&query=122+Optima+Puttappa+Industrial+Estate+Whitefield+Main+Road+Mahadevapura+Bengaluru+560048";
export const CONTACT_MAP_EMBED =
  "https://www.google.com/maps?q=Trifecta+Adatto,+21+ITPL+Main+Rd,+Garudachar+Palya,+Mahadevpura,+Bengaluru,+Karnataka+560048&hl=en&z=16&output=embed";
export const CONTACT_MAP_URL =
  "https://www.google.com/maps/search/?api=1&query=Trifecta+Adatto+21+ITPL+Main+Rd+Garudachar+Palya+Mahadevpura+Bengaluru+560048";

export const SOCIAL_LINKS = {
  facebook: "https://www.facebook.com/webtechsoftwaresolutions/",
  youtube: "https://www.youtube.com/channel/UCbe3fOFpyTTrRJuabt8_BPQ",
  instagram: "https://www.instagram.com/webtech_bangalore/",
  linkedin: "https://in.linkedin.com/company/webtechsoftwaresolutions",
} as const;
